import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d60ab6e")

_pushScopeId("data-v-5d60ab6e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-mb-4 p-text-bold" }
const _hoisted_5 = { class: "p-d-flex p-ml-4 select-button" }
const _hoisted_6 = { class: "p-mr-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_8 = { class: "p-mr-6 p-mb-8" }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "card shadow-box" }
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "p-col" }
const _hoisted_13 = { class: "p-d-flex p-flex-column" }
const _hoisted_14 = { class: "p-mb-2 p-text-light" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_16 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_17 = { class: "p-pl-2" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "p-d-flex p-ai-center" }
const _hoisted_20 = { class: "p-pl-2" }
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = { class: "p-d-flex p-flex-column" }
const _hoisted_23 = { class: "p-mb-2 p-text-light" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_25 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_26 = { class: "p-pl-2" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "p-d-flex p-ai-center" }
const _hoisted_29 = { class: "p-pl-2" }
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = { class: "p-d-flex p-flex-column" }
const _hoisted_32 = { class: "p-mb-2 p-text-light" }
const _hoisted_33 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_34 = { class: "p-d-flex p-flex-column" }
const _hoisted_35 = { class: "p-mb-4" }
const _hoisted_36 = { class: "p-grid" }
const _hoisted_37 = { class: "p-col-6 p-2xl-4" }
const _hoisted_38 = { class: "p-fluid p-grid p-formgrid" }
const _hoisted_39 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_40 = { for: "startDate" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_42 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_43 = { for: "endDate" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_45 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_46 = { for: "startDate" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_48 = { class: "pi pi-info-circle p-mr-4 p-ml-2" }
const _hoisted_49 = { class: "p-d-flex" }
const _hoisted_50 = { class: "p-d-flex p-ai-center" }
const _hoisted_51 = { class: "p-d-flex p-ai-center" }
const _hoisted_52 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_53 = { for: "startDate" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_55 = {
  key: 0,
  class: "p-text-italic p-text-secondary"
}
const _hoisted_56 = {
  key: 1,
  class: "p-error"
}
const _hoisted_57 = {
  key: 2,
  class: "p-error"
}
const _hoisted_58 = {
  key: 3,
  class: "p-error"
}
const _hoisted_59 = { class: "p-col-6 p-2xl-8" }
const _hoisted_60 = {
  key: 1,
  class: "p-col-12"
}
const _hoisted_61 = { class: "p-d-flex p-flex-column" }
const _hoisted_62 = { class: "p-mb-4" }
const _hoisted_63 = { class: "p-grid" }
const _hoisted_64 = { class: "p-col-4" }
const _hoisted_65 = { class: "p-mb-3" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_67 = { class: "p-col-8" }
const _hoisted_68 = { class: "p-mb-3" }
const _hoisted_69 = { class: "p-d-flex" }
const _hoisted_70 = {
  key: 2,
  class: "p-col-12 p-mb-6"
}
const _hoisted_71 = { class: "p-d-flex p-jc-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_BackTestGraph = _resolveComponent("BackTestGraph")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AdvancedSetting = _resolveComponent("AdvancedSetting")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("autots.create.label.ds.name")), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.datasourceName), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "datasource-detail",
              to: `/workspace/${_ctx.workspaceId}/datasource/${_ctx.id}`,
              target: "_blank"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.link.details")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_Button, {
            type: "Button",
            label: _ctx.$t('datasource.metadata.link.change.datasource'),
            class: "p-button-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectDatasource()))
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("autots.create.header.predicttarget")), 1),
                _hoisted_15
              ]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.targetColumn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.targetColumn = $event)),
                options: 
                  _ctx.autoTsSchemas.filter(
                    (e) => e.type == 'integer' || e.type == 'float'
                  )
                ,
                optionLabel: _ctx.targetColumn.name,
                filter: true,
                placeholder: _ctx.$t('autots.create.select'),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeTargetColumn($event))),
                showClear: _ctx.showClearTarget,
                class: {
                  'p-invalid': _ctx.targetColumn.name.length == 0,
                }
              }, {
                value: _withId((slotProps) => [
                  (slotProps.value.name)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode(_component_DataType, {
                          dataType: slotProps.value.type
                        }, null, 8, ["dataType"]),
                        _createVNode("div", _hoisted_17, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withId((slotProps) => [
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_DataType, {
                      dataType: slotProps.option.type
                    }, null, 8, ["dataType"]),
                    _createVNode("div", _hoisted_20, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "optionLabel", "placeholder", "showClear", "class"])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createTextVNode(_toDisplayString(_ctx.$t("autots.create.header.datecolumn")), 1),
                _hoisted_24
              ]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.dateColumn,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateColumn = $event)),
                options: _ctx.autoTsSchemas.filter((e) => e.type == 'date'),
                optionLabel: _ctx.dateColumn.name,
                filter: true,
                placeholder: _ctx.$t('autots.create.select'),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeDateColumn($event))),
                showClear: _ctx.showClearTimeSeries,
                class: {
                  'p-invalid': _ctx.dateColumn.name.length == 0,
                },
                autofocus: ""
              }, {
                value: _withId((slotProps) => [
                  (slotProps.value.name)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        _createVNode(_component_DataType, {
                          dataType: slotProps.value.type
                        }, null, 8, ["dataType"]),
                        _createVNode("div", _hoisted_26, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withId((slotProps) => [
                  _createVNode("div", _hoisted_28, [
                    _createVNode(_component_DataType, {
                      dataType: slotProps.option.type
                    }, null, 8, ["dataType"]),
                    _createVNode("div", _hoisted_29, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "optionLabel", "placeholder", "showClear", "class"])
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("autots.create.header.IDCs")), 1),
              _createVNode(_component_MultiSelect, {
                modelValue: _ctx.selectedIDCKeys,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedIDCKeys = $event)),
                options: _ctx.idcs,
                optionLabel: "name",
                placeholder: _ctx.$t('autots.create.select'),
                class: "multiselect-custom",
                display: "chip",
                onChange: _ctx.onChangeKeysList,
                disabled: _ctx.disabledMultiSelect
              }, null, 8, ["modelValue", "options", "placeholder", "onChange", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.dateColumn.name != '')
      ? (_openBlock(), _createBlock("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("strong", _hoisted_35, _toDisplayString(_ctx.$t("autots.create.label.config.infor")), 1),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _createVNode("label", _hoisted_40, [
                      _createTextVNode(_toDisplayString(_ctx.$t("autots.label.start_date")), 1),
                      _hoisted_41
                    ]),
                    _createVNode(_component_Calendar, {
                      id: "startDate",
                      modelValue: _ctx.dateRangeFrom,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dateRangeFrom = $event)),
                      dateFormat: "yy-mm-dd",
                      maxDate: _ctx.maxStartDate,
                      monthNavigator: true,
                      yearNavigator: true,
                      manualInput: false
                    }, null, 8, ["modelValue", "maxDate"])
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode("label", _hoisted_43, [
                      _createTextVNode(_toDisplayString(_ctx.$t("autots.label.end_date")), 1),
                      _hoisted_44
                    ]),
                    _createVNode(_component_Calendar, {
                      id: "endDate",
                      modelValue: _ctx.dateRangeTo,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dateRangeTo = $event)),
                      dateFormat: "yy-mm-dd",
                      minDate: _ctx.minEndDate,
                      monthNavigator: true,
                      yearNavigator: true,
                      manualInput: false
                    }, null, 8, ["modelValue", "minDate"])
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("label", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_ctx.$t("autots.create.label.forecast.duration")), 1),
                      _hoisted_47,
                      _withDirectives(_createVNode("i", _hoisted_48, null, 512), [
                        [
                          _directive_tooltip,
                          
                      _ctx.$t('autots.create.label.forecast.input.haft.size')
                    ,
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _createVNode("div", _hoisted_49, [
                      _createVNode(_component_InputNumber, {
                        id: "input-forecast-duration",
                        modelValue: _ctx.forecastDuration,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.forecastDuration = $event)),
                        mode: "decimal",
                        min: _ctx.minForecastDuration,
                        max: _ctx.maxForecastDuration,
                        class: {
                      'p-invalid':
                        _ctx.forecastDuration < 1 ||
                        _ctx.forecastDuration > _ctx.maxForecastDuration,
                    }
                      }, null, 8, ["modelValue", "min", "max", "class"]),
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.forecastFrequency,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.forecastFrequency = $event)),
                        options: _ctx.forecastFrequencyOptions,
                        optionLabel: "label",
                        style: {"min-width":"70%"}
                      }, {
                        value: _withId((slotProps) => [
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.value.label)), 1)
                          ])
                        ]),
                        option: _withId((slotProps) => [
                          _createVNode("div", _hoisted_51, [
                            _createVNode("div", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _createVNode("label", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_ctx.$t("autots.create.label.gap")), 1),
                      _hoisted_54
                    ]),
                    _createVNode(_component_InputNumber, {
                      id: "input-gap",
                      modelValue: _ctx.gap,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.gap = $event)),
                      mode: "decimal",
                      min: _ctx.minForecastGap,
                      max: _ctx.maxForecastGap,
                      suffix: _ctx.$t(_ctx.forecastFrequency.label)
                    }, null, 8, ["modelValue", "min", "max", "suffix"])
                  ])
                ]),
                (_ctx.maxForecastDuration > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_55, _toDisplayString(_ctx.$t("autots.create.label.forecast.range", {
                  min: _ctx.minForecastDuration,
                  max: _ctx.maxForecastDuration,
                  frequency: _ctx.$t(_ctx.forecastFrequency.label),
                })), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_56, _toDisplayString(_ctx.$t("autots.create.label.forecast.range.error")), 1)),
                (_ctx.warningEndDate === 'W')
                  ? (_openBlock(), _createBlock("div", _hoisted_57, _toDisplayString(_ctx.$t("autots.create.label.end.time.warning.week", {
                  date: _ctx.$moment(_ctx.dateRangeTo).format("YYYY-MM-DD"),
                })), 1))
                  : (_ctx.warningEndDate === 'M')
                    ? (_openBlock(), _createBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("autots.create.label.end.time.warning.month", {
                  date: _ctx.$moment(_ctx.dateRangeTo).format("YYYY-MM-DD"),
                })), 1))
                    : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_59, [
                _createVNode(_component_BackTestGraph, {
                  train: _ctx.totalDate - _ctx.gap - _ctx.forecastDuration,
                  gap: _ctx.gap,
                  test: _ctx.forecastDuration,
                  frequency: _ctx.forecastFrequency
                }, null, 8, ["train", "gap", "test", "frequency"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dateColumn.name != '')
      ? (_openBlock(), _createBlock("div", _hoisted_60, [
          _createVNode("div", _hoisted_61, [
            _createVNode("strong", _hoisted_62, _toDisplayString(_ctx.$t("autots.create.label.config.metric")), 1)
          ]),
          _createVNode("div", _hoisted_63, [
            _createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, [
                _createTextVNode(_toDisplayString(_ctx.$t("label.primary_metric")), 1),
                _hoisted_66
              ]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedPrimaryMetric,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedPrimaryMetric = $event)),
                options: _ctx.primaryMetricOptions
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("label.other_metrics")), 1),
              _createVNode("div", _hoisted_69, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metricOptions.filter(
                (x) => x !== _ctx.selectedPrimaryMetric
              ), (metric) => {
                  return (_openBlock(), _createBlock("div", {
                    key: metric,
                    class: "p-field-checkbox p-mr-6"
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: metric,
                      name: "metric",
                      value: metric,
                      modelValue: _ctx.otherMetrics,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.otherMetrics = $event))
                    }, null, 8, ["id", "value", "modelValue"]),
                    _createVNode("label", { for: metric }, _toDisplayString(metric), 9, ["for"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_Button, {
            label: _ctx.$t('automl.create.advanced.setting'),
            class: "p-button-link p-p-0",
            onClick: _ctx.openAdvancedSetting
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_AdvancedSetting, {
            visible: _ctx.displayAdvancedSetting,
            "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_ctx.displayAdvancedSetting = $event)),
            opening: _ctx.displayAdvancedSetting,
            autoTsSchemas: _ctx.getRemainColumn,
            algorithms: _ctx.algorithms,
            selectedAdvancedSettingModel: _ctx.advancedSettingModel,
            selectedAdvancedSettingPostProcessing: _ctx.advancedSettingPostProcessing,
            selectedAdvancedSettingColumn: _ctx.advancedSettingColumn,
            selectedAdvancedSettingLimitTime: _ctx.advancedSettingLimitTime,
            onOnSetting: _ctx.onAdvancedSetting
          }, null, 8, ["visible", "opening", "autoTsSchemas", "algorithms", "selectedAdvancedSettingModel", "selectedAdvancedSettingPostProcessing", "selectedAdvancedSettingColumn", "selectedAdvancedSettingLimitTime", "onOnSetting"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dateColumn.name != '')
      ? (_openBlock(), _createBlock("div", _hoisted_70, [
          _createVNode("div", _hoisted_71, [
            _createVNode(_component_Button, {
              label: _ctx.$t('button.create.experiment.start'),
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.Complete())),
              disabled: !_ctx.isEnableCreateButton,
              loading: _ctx.processing,
              style: {"width":"100%"}
            }, null, 8, ["label", "disabled", "loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})